

const TableSort = function(order, sort, page, callback){
  if(sort === undefined) return;
  let orderKey = order.order || order.property;
  if (!orderKey) {
    console.error('请配置：排序列名（order）')
    return
  } 
  let arr = []; 
  if(!page['sortings']) page['sortings'] = [];// 存储 page中已经存在的排序的列名为数组
  page['sortings'].forEach((im)=>{
    arr.push(im.field)
  })
  // 如果arr.lengt>0 说明已经有存在的排序字段,如果当前排序字段存在,那么就更新他的order值,如果不存在就直接push
  const index = arr.indexOf(orderKey)

  if(arr[index]){ 
    page['sortings'].splice(index, 1);
  }

  if(sort !== null) {
    page['sortings'].push({
      field: orderKey,
      order: sort,
    });
  }
  
  if(callback) callback();
}

export {TableSort};

  